// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Use4","buttons":"Footer_buttons__23Azv"};